import React from 'react'
import PropTypes from 'prop-types'
import { Route } from 'react-router-dom'
import LocationDetector from './LocationDetector'
import { geocodePlace } from 'commons/js/services/geocoderService'

const DefaultRoute = ({ defaultParams = {}, ...rest }) => (
    <Route
      {...rest}
      render={(props) => (
          <LocationDetector
            geocodePlace={geocodePlace}
            defaultParams={defaultParams}
            {...props}
          />
      )}
    />
)

DefaultRoute.propTypes = {
    component: PropTypes.func,
    defaultParams: PropTypes.object,
    location: PropTypes.object,
}

export default DefaultRoute
